import React from 'react';
import { FollowUpQuestionContent, FollowUpQuestionCategory } from 'models/user/research/FollowUpQuestion.model';
import CircleLoader from 'components/CircleLoader/CircleLoader';
import './FollowUpQuestions.scss';

export type FollowUpQuestionsProps = {
  followUpQuestionContent: FollowUpQuestionContent;
  onQuestionClick?: (question: string, index: number) => void;
  onRefresh?: () => void;
  className?: string;
  title?: string;
  isLoading?: boolean;
};

const FollowUpQuestions: React.FC<FollowUpQuestionsProps> = ({ 
  followUpQuestionContent, 
  onQuestionClick,
  onRefresh,
  className = '',
  title = 'Follow-up Questions',
  isLoading
}) => {
  if (!followUpQuestionContent) {
    return null;
  }

  const handleQuestionClick = (question: string, index: number) => {
    if (onQuestionClick) {
      onQuestionClick(question, index);
    }
  };

  const { followUpQuestions = [], hasError } = followUpQuestionContent;

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  return (
    <div className='follow-up-questions-wrapper'> 
      {!hasError && followUpQuestions.length > 0 && <h4 className="follow-up-questions__title">{title}</h4> }
      <div className={`follow-up-questions ${className}`}>
        {hasError && (
          <div className="follow-up-questions__error">
            <div className="follow-up-questions__error-content">
              <i className="material-icons follow-up-questions__error-icon">error_outline</i>
              <p className="follow-up-questions__error-message">
                There was a problem getting follow-up questions.
              </p>
              {isLoading && <p className="follow-up-questions__loading"><CircleLoader isActive={true} /></p>}
              { !isLoading && (
                <button
                  className="follow-up-questions__refresh-button"
                  onClick={handleRefresh}
                  type="button"
                >
                  <i className="material-icons">refresh</i>
                  Try Again
                </button>
              )}
            </div>
          </div>
        )}
        
        {!hasError && followUpQuestions.length < 1 && (
          <p className='follow-up-questions__no-results'>No follow-up questions available.</p>
        )}
        
        {!hasError && followUpQuestions.map((fuq: FollowUpQuestionCategory) => (
          <div key={fuq.category} className='follow-up-questions__category'>
            <h5 className='follow-up-questions__title'>{fuq.category}</h5>
            <ul className='follow-up-questions__list'>
              {fuq.questions.map((question, index) => (
                <li key={index} className='follow-up-questions__item'>
                  <button
                    className='follow-up-questions__button'
                    onClick={() => handleQuestionClick(question, index)}
                    type='button'
                  >
                    <span className='follow-up-questions__text'>
                      {question}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FollowUpQuestions;
